export default {
  title: '防伪管理2',
  qrCodeList: '二维码列表',
  scanRecords: '扫码记录',
};
